import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
/* eslint-disable @typescript-eslint/no-shadow */
import { FollowUp, PharmacySubmit } from '@brands/Dashboard/ConsultationPage/assets/types';

import { client } from '../client';
import { IEducation } from './types/IEducation';
import { IOneReport } from './types/IOneReport';

export enum ObjectType {
  Prescription = 'prescription',
  Pharmacy = 'pharmacy',
  FollowUp = 'follow_up',
  Education = 'education',
  Treatment = 'treatment',
  FulfillmentApproval = 'fulfillment_approval',
}
export interface ITreatmentsOptoinal {
  category?: string;
  tooth_area?: string;
  tooth_number?: string;
  description?: string;
  urgency?: string;
  id?: string;
}

export interface IPrescriptionOptoinal {
  drug?: string;
  sig?: string;
  prescription_date?: string;
  dispense?: string;
  refills?: string;
  id?: string;
  pharmacy: {
    pharmacy_name: string;
    pharmacy_street_address: string;
    pharmacy_city: string;
    pharmacy_state: string;
    pharmacy_zip_code: string;
    pharmacy_phone_number: string;
  };
}

export interface IFulfillmentApprovalPayload {
  id?: string;
  approved: boolean;
  notes: string;
}

export const updateOneReportObject = async (
  one_report_id: string,
  object_type: ObjectType,
  payload:
    | ITreatmentsOptoinal
    | IPrescriptionOptoinal
    | IEducation
    | PharmacySubmit
    | FollowUp
    | IFulfillmentApprovalPayload,
  userRole?: string,
): Promise<IOneReport> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.put<IOneReport>(
    `${prefix}/one_reports/${one_report_id}/${object_type}/${payload.id}`,
    payload,
  );

  return data;
};
